export default function UserIcon({ width = "30px", fill = "#000" }: { width?: string, fill?: string }) {
    return (
        <svg fill={fill} width={width} id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.54 60.16">
            <g id="Layer_1-2" data-name="Layer_1">
                <path d="M28.77,0c-8.67,0-15.69,7.03-15.69,15.69v2.62c0,8.67,7.03,15.69,15.69,15.69s15.69-7.03,15.69-15.69v-2.62c0-8.67-7.03-15.69-15.69-15.69ZM18.56,43.29c-7.68,2.01-14.92,5.78-17.59,9.26-2.39,3.11-.11,7.61,3.81,7.61h47.97c3.92,0,6.2-4.5,3.81-7.61-2.67-3.47-9.91-7.25-17.58-9.25-2.75,2.36-6.31,3.79-10.21,3.79s-7.46-1.43-10.21-3.79Z" />
            </g>
        </svg>
    )
}
